import { Component } from 'preact';
import { connect } from 'unistore/preact';
import {
  setAccountDetails,
  clearFieldError,
  validateMandateAuthDetails,
  displayConfirmationScreen,
  closeSubsConfirmScreen,
  onConfirmSubmit
} from '../../controllers/bank-mandate';
import BankAuthenticate from '../bank-mandate/bank-authenticate';

import BankDetailsConfirm from '../bank-mandate/bank-details-confirm';
import { locale } from '../../utils/i18n';
import { onChange } from '../../common/actions';
import OverlayWrap from '../OverlayWrap';
import CONSTANT, { CACHE } from '../../utils/constants';
import { getKey } from '../../utils/common';
import { postInWindow } from '../../utils/formPost';
import { log, EVENT } from '../../common/logger';

class SavedBankMandate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmationScreen: false,
      authModeError: '',
      isAuthModeError: false,
      mandateAuthMode: '',
      authenticateModes: [],
      btnDisabled: false,
      genericError: ''
    };
    this.accountDetails = setAccountDetails(props.option || {});
    this.populateBank();
    this.authModeData = { blank: locale('bm.blank.auth') };
  }

  populateBank = () => {
    this.accountDetails.channelCode && this.setSelectedBank();
  };

  setSelectedBank = () => {
    this.optedBankData = {
      iconUrl: this.accountDetails.iconUrl,
      mandateAuthMode: this.accountDetails.mandateAuthMode,
      channelName: this.accountDetails.channelName,
      channelCode: this.accountDetails.channelCode
    };
    this.authenticateModes = this.accountDetails.mandateAuthMode;
  };

  clearError = type => {
    this.setState(clearFieldError(type));
  };

  selectAuthMode = mode => {
    this.setState({ mandateAuthMode: mode });
    this.clearError('authMode');
  };

  closeConfirmScreen = () => {
    this.setState(closeSubsConfirmScreen());
  };

  submit = () => {
    this.onProceed();
  };

  onProceed = () => {
    const data = validateMandateAuthDetails(this.state.mandateAuthMode, this.authModeData);
    if (data) {
      this.setState(data.stateData);
      if (data.submit) {
        const mandateAuthMode = this.state.mandateAuthMode;
        this.accountDetails = setAccountDetails({ ...this.accountDetails, mandateAuthMode });
        const stateData = displayConfirmationScreen();
        this.setState(stateData);
      }
    }
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
    this.props.onBtnTextChange('Proceed');
    this.props.onPayChange(true);
  };

  onConfirm = () => {
    this.setState({ genericError: '', btnDisabled: false });
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
    log({ eventType: EVENT.BUTTON_CLICK, payMode: CONSTANT.SBM });
    onConfirmSubmit(this.accountDetails, this.optedBankData, true, this.props.cache)
      .then(response => {
        const notifyMerchant = getKey(
          this.props.cache.getData(CACHE.MERCHANT_CONFIG),
          'handler.notifyMerchant',
          undefined
        );
        if (getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
          const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', undefined);
          response.body.content = content;
          response.body.callbackUrl = actionUrl;
          this.setState({ genericError: '', btnDisabled: false });
        } else {
          this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
          const errorMsg = getKey(response, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, response);
          }
          this.setState({ genericError: errorMsg, btnDisabled: true });
        }
        postInWindow(response, this.props.cache);
      })
      .catch(res => {
        this.setState(res);
        const notifyMerchant = getKey(
          this.props.cache.getData(CACHE.MERCHANT_CONFIG),
          'handler.notifyMerchant',
          undefined
        );
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
          notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, CONSTANT.GENERIC_ERROR);
        }
        postInWindow({}, this.props.cache); // close window in case of network error
      });
  };

  render(
    { showLoader, option, isActive, instanceKey },
    { mandateAuthMode, authModeError, showConfirmationScreen, genericError }
  ) {
    return (
      <section className="ptm-sbm-main-wrap">
        <div className="ptm-pay-method ptm-w100-ib" id="checkout-sbm">
          <div className="ptm-radio-wrap">
            <label className="ptm-lbl">
              <input
                type="radio"
                name={`verify${instanceKey}`}
                className="ptm-margin0"
                checked={isActive}
                onClick={() => {
                  this.onOptionSelect(option);
                }}
              />
              <span class="ptm-checkmark" />
              <div class={`ptm-pay-method-cont`}>
                <p class={`ptm-paymode-name `}>
                  {option.displayName}
                  <span className={`ptm-card-type-img ${option.cardScheme}`} />
                </p>
                <p class={`ptm-small-txt`}>
                  <span>A/C No. XXXX {option.lastFour}</span>
                  {option.iconUrl && (
                    <img className={`ptm-ib ptm-vm ptm-mand-img`} src={option.iconUrl} alt="" />
                  )}
                </p>
              </div>
            </label>
          </div>
        </div>
        {option && isActive && (
          <div className={`ptm-nb-inner ptm-pl-35`}>
            <BankAuthenticate
              authenticateModes={this.authenticateModes}
              selectMode={this.selectAuthMode}
              authModeError={authModeError}
              populateMode={mandateAuthMode}
            />
            {showConfirmationScreen && (
              <OverlayWrap>
                <BankDetailsConfirm
                  optedBankData={this.optedBankData}
                  accountDetails={this.accountDetails}
                  {...{ genericError, showLoader }}
                  onConfirm={this.onConfirm}
                  closeConfirmScreen={this.closeConfirmScreen}
                />
              </OverlayWrap>
            )}
          </div>
        )}
      </section>
    );
  }
}
export default connect(
  'cache, instanceKey',
  onChange
)(SavedBankMandate);



// WEBPACK FOOTER //
// ./components/savedBankMandate/index.js